import { z } from 'zod';

export const importSearchSchema = z.object({
  query: z.string().optional(),
  sort: z.string().optional(),
  direction: z.enum(['asc', 'desc']).optional(),
  state: z.array(z.string()).optional(),
});

export type ImportSearchParams = z.infer<typeof importSearchSchema>;
